<template>
    <b-card no-body bg-variant="light">
        <div class="card-header">
            <b-card-title>
                {{ concernElement.substance.title }}
            </b-card-title>
        </div>
        <div class="pl-2">
            <span>
                <b-badge class="mr-1">CAS: {{ concernElement.substance.cas }}</b-badge>
                <b-badge>EC: {{ concernElement.substance.ec }}</b-badge>
            </span>
        </div>
        <div class="card-body">
            <b-row>
                <b-col md="6" lg="6">
                    <b-row>
                        <b-col md="6" lg="6">
                            <b-card no-body>
                                <div class="card-header">
                                    <h5>Regulations</h5>
                                </div>
                                <b-list-group flush>
                                    <b-list-group-item class="pl-2">REACH Article 33</b-list-group-item>
                                    <b-list-group-item class="pl-2">WFD Article 9</b-list-group-item>
                                </b-list-group>
                            </b-card>
                        </b-col>
                        <b-col md="6" lg="6">
                            <b-card>
                                <div>
                                    <h5 class="text-capitalize mb-75">Max conc. (w/w %)</h5>
                                    <p class="card-text">{{ maxConcentrationRange }}</p>
                                </div>
                                <div class="mt-2">
                                    <h5 class="text-capitalize mb-75">SCIP interval</h5>
                                    <p class="card-text">{{ concentrationRange ? concentrationRange.title : '-' }}</p>
                                </div>
                                <div></div>
                            </b-card>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md="6" lg="6">
                    <b-card>
                        <div>
                            <h5 class="text-capitalize mb-75">Material category</h5>
                            <p class="card-text">{{ materialCategory ? materialCategory.title : '-' }}</p>
                        </div>
                        <div class="mt-2">
                            <h5 class="text-capitalize mb-75">Additional material category</h5>
                            <p class="card-text">{{ additionalMaterial ? additionalMaterial.title : '-' }}</p>
                        </div>
                        <div class="mt-2">
                            <h5 class="text-capitalize mb-75">Mixture category</h5>
                            <p class="card-text">{{ mixtureCategory ? mixtureCategory.title : '-' }}</p>
                        </div>
                    </b-card>
                </b-col>
            </b-row>
        </div>
    </b-card>
</template>

<script>
import { BCard, BCardTitle, BCardBody, BRow, BCol, BBadge, BListGroup, BListGroupItem, } from 'bootstrap-vue'

export default {
    components: {
        BCard, BCardBody, BRow, BCol, BBadge, BCardTitle, BListGroup, BListGroupItem,
    },
    props: {
        concernElement: {
            required: true,
            default() {
                return [];
            }
        }
    },
    methods: {
        getDetails() {
            if (this.concernElement.details && this.concernElement.details.length > 0) {
                return this.concernElement.details[0];
            }

            return {
                materialCategory: null,
                mixtureCategory: null,
                additionalMaterial: null,
                concentrationRange: null,
                maxConcentrationRange: '-'
            };
        }
    },
    computed: {
        materialCategory() {
            return this.details.materialCategory;
        },
        mixtureCategory() {
            return this.details.mixtureCategory;
        },
        additionalMaterial() {
            return this.details.additionalMaterial;
        },
        concentrationRange() {
            return this.details.concentrationRange;
        },
        maxConcentrationRange() {
            return this.details.maxConcentrationRange ?? '-';
        },
        details() {
            return this.concernElement.details;
        }
    }
}
</script>
